module.exports = __webpack_public_path__ + "static/img/10042U_1_2_3_C_20230520_LC.d38cc9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/10042U_1_2_3_C_20230520_LC.png
// module id = 19eP
// module chunks = 0